import { render, staticRenderFns } from "./channelData.vue?vue&type=template&id=09ca796f&scoped=true&"
import script from "./channelData.vue?vue&type=script&lang=js&"
export * from "./channelData.vue?vue&type=script&lang=js&"
import style0 from "./channelData.vue?vue&type=style&index=0&id=09ca796f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca796f",
  null
  
)

export default component.exports